// Callers build one vitals object that is reused for the consultation action
// payload, which needs recordedAt/vitalType/vitalTypeKey/recordedVitalType and
// PascalCase keys. The add-patient-vitals API (PatientVitalsModel) doesn't accept
// those fields, and expects camelCase keys at every level (patientId,
// bloodPressure.systolic.value).
const DROPPED_KEYS = new Set([
  "recordedAt",
  "vitalType",
  "vitalTypeKey",
  "recordedVitalType",
]);

const toCamelCase = (key) => key.charAt(0).toLowerCase() + key.slice(1);

export const toPatientVitalsRequest = (data) => {
  if (Array.isArray(data)) return data.map(toPatientVitalsRequest);
  if (!data || typeof data !== "object") return data;

  return Object.entries(data).reduce((acc, [key, value]) => {
    if (!DROPPED_KEYS.has(key)) {
      acc[toCamelCase(key)] = toPatientVitalsRequest(value);
    }
    return acc;
  }, {});
};
